export enum OrdnerEnum {
  GESENDET = 'gesendet',
  ERHALTEN = 'erhalten',
  GELOESCHT = 'geloescht',
  ENTWURF = 'entwurf'
}

export function getOrdnerEnum(ordner: string): OrdnerEnum | undefined {
  const normalized = ordner.toLowerCase();
  const values = Object.values(OrdnerEnum) as string[];
  return values.includes(normalized) ? (normalized as OrdnerEnum) : undefined;
}

